module.exports = __webpack_public_path__ + "img/Assessment.0ff33ac3.png";